export const _sharedActionsConstantsLibrary = {
  ACTION_SAVE_LISTEN: "ACTION_SAVE_LISTEN",
  ACTION_SAVE_READ: "ACTION_SAVE_READ",
  ACTION_SAVE_ALL: "ACTION_SAVE_ALL",
  UPDATE_ALL_HISTORY: "UPDATE_ALL_HISTORY",
  FETCH_ALL_BOOKS_DATA: "FETCH_ALL_BOOKS_DATA",
  TOGGLE_BOOK_IN_ML_BY_ID: "TOGGLE_BOOK_IN_ML_BY_ID",
  SET_LIBRARY_LANGUAGES: "SET_LIBRARY_LANGUAGES",
};

export const _sharedActionsLibrary = {
  saveListen: (chapterId, position, saveML, delay, localItemDateISO, skipSaveOnServer) => ({
    type: _sharedActionsConstantsLibrary.ACTION_SAVE_LISTEN,
    data: { chapterId, position: position, saveML, delay,
      localItemDateISO, skipSaveOnServer, },
  }),
  saveRead: (chapterId, paraId, saveML, delay, localItemDateISO, skipSaveOnServer) => ({
    type: _sharedActionsConstantsLibrary.ACTION_SAVE_READ,
    data: { chapterId, paraId, justSync: !paraId, saveML, delay,
      localItemDateISO, skipSaveOnServer, },
  }),
  saveAll: (chapterId, paraId, position, saveML, delay, localItemDateISO, skipSaveOnServer) => ({
    type: _sharedActionsConstantsLibrary.ACTION_SAVE_ALL,
    data: { chapterId, paraId, justSync: !paraId, position: position, saveML, delay,
      localItemDateISO, skipSaveOnServer, },
  }), 
  updateAllHistory: (userId, payload) => ({
    type: _sharedActionsConstantsLibrary.UPDATE_ALL_HISTORY,
    data: { userId, payload },
  }),
  fetchAllBooksData: (start, onSuccess, onFinally) => ({
    type: _sharedActionsConstantsLibrary.FETCH_ALL_BOOKS_DATA,
    data: { start, onSuccess, onFinally },
  }),
  toggleBookInMLById: (bookId) => ({
    type: _sharedActionsConstantsLibrary.TOGGLE_BOOK_IN_ML_BY_ID,
    data: bookId,
  }),
  setLibraryLanguages: (data) => ({
    type: _sharedActionsConstantsLibrary.SET_LIBRARY_LANGUAGES,
    data,
  }),
};
